import { render, staticRenderFns } from "./FestivalDialog.vue?vue&type=template&id=660315bd&scoped=true"
import script from "./FestivalDialog.vue?vue&type=script&lang=js"
export * from "./FestivalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660315bd",
  null
  
)

export default component.exports